@defer (when telemetry()) {
  <div id="main" style="width: 100%" [ngStyle]="{ height: height() }"></div>
  <script type="text/javascript">
    var myChart = echarts.init(document.getElementById('main'), null);
  </script>
}
